import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DatePicker from 'react-datepicker';
import Immutable from 'immutable';
import _ from 'lodash';
import querystring from 'querystring';
import moment from 'moment';
import { browserHistory } from '../../../redux/configureStore';
import SearchTypesOfCaseLookup from '../../../components/search/FormElements/SearchTypesOfCaseLookup';
import OrSeparator from '../../../components/search/FormElements/OrSeparator';
import ActionButtonOfCaseLookup from '../../../components/search/FormElements/ActionButtonOfCaseLookup';
import CaseNumberSelector from '../../../components/search/FormElements/caseSelector/CaseNumberSelectorOfCaseLookup';
import CaseTitleSelector from '../../../components/search/FormElements/caseSelector/CaseTitleOrPartyNameSelectorOfCaseLookup';
import ArrowFormElement from '../../../components/search/FormElements/ArrowFormElement';
import ResultColumnHeadTextFormElement from '../../../components/search/FormElements/ResultColumnHeadTextFormElement';
import Collapsible from '../../../components/common/Collapsible';
import AlertError from '../../../components/common/AlertError';
import Loading from '../../../components/common/Loading';
import { search as caseLookupSearch } from '../../../components/search/sections/util/caseLookup';
import { firstLetterCapitalize } from '../../../util/text';
import { initialFilters } from '../../../redux/reducers/caseLookupSearchReducer';
import PaginatorItem from '../../../components/search/FormElements/paginatorItem/PaginatorItem';
import * as errorConstants from '../../../redux/actionTypes/errorActionTypes';
import * as actions from '../../../redux/actions/caseLookupSearchAction';
import * as errorActions from '../../../redux/actions/errorAction';
import * as actionsOfPacerSearch from '../../../redux/actions/pacerSearch';
import RegionSelector from '../../../components/search/FormElements/regionSelector/RegionSelector';
import sortRegions from '../../../data/regionsSorter';
import courtsFromFile from '../../../data/courts';
import actualRegions from '../../../data/regions';
import { isCourtDrive, isProd } from '../../../util/globalUtils';

import './caseLookup.less';


const courtDriveSearchTypes = [
  'All',
  'Bankruptcy',
  'Civil',
  'Criminal',
  'Appellate',
  'National',
];

const inforuptcySearchTypes = [
  'Bankruptcy',
];

const searchTypes = isCourtDrive() ? courtDriveSearchTypes : inforuptcySearchTypes;

const regions = (isProd())
  ? courtsFromFile.filter(p => !p.is_test)
  : courtsFromFile;

const courtToRegionOption = ({ code, name }) => ({ value: code, label: name });


class CaseLookupSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFirstLoad: true,
      caseNumShowFlash: false,
      caseTitleShowFlash: false,
    };
  }

  componentDidMount() {
    this.browserRouterListener(browserHistory.location);
  }

  valueDebounce = _.debounce((name) => {
    if (name === 'case_no') {
      this.searchClickHandle('case_no', true);
    } else {
      this.searchClickHandle('party_title', true);
    }
  }, 500);

  searchAction = {
    All: this.props.actionsOfPacerSearch.searchCivil,
    Bankruptcy: this.props.actionsOfPacerSearch.searchBankruptcies,
    Civil: this.props.actionsOfPacerSearch.searchCivil,
    Criminal: this.props.actionsOfPacerSearch.searchCriminal,
    Appellate: this.props.actionsOfPacerSearch.searchAppellates,
  };

  bkRegions = regions.filter(p => p.type === 'bankruptcy')
    .map(courtToRegionOption);

  dcRegions = regions.filter(p => p.type === 'district')
    .map(courtToRegionOption);

  apRegions = regions.filter(p => p.type === 'appellate')
    .map(courtToRegionOption);

  nationalRegions = regions.filter(p => p.type === 'national')
    .map(courtToRegionOption);

  allRegions = regions.map(courtToRegionOption);

  regionOptions = {
    All: this.allRegions,
    Bankruptcy: this.bkRegions.concat(actualRegions),
    Civil: this.dcRegions.concat(actualRegions),
    Criminal: this.dcRegions.concat(actualRegions),
    Appellate: this.apRegions.concat(actualRegions),
    National: this.nationalRegions,
  };

  browserRouterListener = (location) => {
    console.log("Browser Router Listener");
    const query = querystring.parse(location.search.slice(1));

    const searchType = query.search_type;
    query[searchType] = query.search_term;

    delete query.search_term;

    if (query.case_type) {
      query.case_type = firstLetterCapitalize(query.case_type);
    }

    for (const key in query) {
      const queryValue = query[key];

      if (this.props.filters.get(key) == queryValue) continue;

      const isDateField = key === 'filed_from' || key === 'filed_to';

      let value = (isDateField && typeof queryValue === 'string')
        ? moment(queryValue)
        : queryValue;

      value = (key === 'page')
        ? parseInt(value)
        : value;

      this.props.actions.updateFilter({ [key]: value });
    }

    this.valueDebounce(searchType);
  };

  resetFilters = () => {
    // this.props.actions.resetFilters()
  };

  searchClickHandle = (search_type, forceSearch) => {
    // if length of case number less than 4 or party title was empty then do nothing.
    const isEmpty = _.isEqual(initialFilters, this.props.filters.toJS());

    const party_title = this.props.filters.get('party_title');
    const case_no = this.props.filters.get('case_no');
    if (search_type === 'case_no' && case_no.length === 0 && !this.state.isFirstLoad) {
      this.setState({ caseNumShowFlash: true }, _.debounce(() => {
        this.setState({ caseNumShowFlash: false });
      }, 1000));
    }

    if (search_type === 'party_title' && party_title.length === 0 && !this.state.isFirstLoad) {
      this.setState({ caseTitleShowFlash: true }, _.debounce(() => {
        this.setState({ caseTitleShowFlash: false });
      }, 1000));
    }

    this.setState({ isFirstLoad: false });

    if (
      !forceSearch || (
        (search_type == 'case_no' && case_no.length < 4) || isEmpty ||
        (search_type == 'party_title' && party_title.length == 0)
      )
    ) return;

    this.props.actions.updateFilter({ search_type });
    caseLookupSearch.bind(this)({ search_type }, false);
  };

  handleDateChangeRaw = (datePosition, data) => {
    if (data.split('/').length !== 3) {
      return;
    }

    const sanitized = data.split('/').reduce((accum, next, idx) => {
      const n = (next.length < 2)
        ? `0${next}`
        : next;

      return (idx === 0)
        ? accum + n
        : `${accum}/${n}`;
    }, '');

    this.stateValueSet(datePosition, moment(sanitized, 'MM-DD-YYYY'));
  }

  stateValueSet = (name, e) => {
    const value = (name === 'region_name')
      ? _.get(e, 'target.value', e).court_id
      : _.get(e, 'target.value', e);

    const isDateField = name === 'filed_from' || name === 'filed_to';
    const { filters } = this.props;
    const searchFieldsEmpty = _.isEmpty(filters.get('case_no')) && _.isEmpty(filters.get('party_title'));

    let newFilters = (isDateField && searchFieldsEmpty)
      ? { [name]: value, party_title: '*' }
      : { [name]: value };

    if (name === 'case_type') {
      newFilters = { ...newFilters, region_name: null };
    }

    this.props.actions.updateFilter(newFilters);

    if (
      name === 'case_type'
      // why were we doing this before?
      // || (isDateField && value == null)
    ) return;

    // dont search if under 3 chars
    if (name !== 'region_name' && typeof value === 'string' && value.length < 3) {
      return;
    }

    const search_type = (name === 'party_title' || name === 'case_no')
      ? name
      : this.props.filters.get('search_type');

    this.valueDebounce(search_type);
  };

  clearDateFilters = () => {
    this.stateValueSet('filed_from', null);
    this.stateValueSet('filed_to', null);
  };

  changeSortBy = () => {
    const sort = this.props.filters.get('sort') === 'asc' ? 'desc' : 'asc';
    console.log("Flipping sort from", this.props.filters.get('sort'), "to", sort);

    this.props.actions.updateFilter({ sort });
    caseLookupSearch.bind(this)({ sort }, false);
  };

  changeOrder = (order) => {
    if (order === this.props.filters.get('order')) {
      this.changeSortBy();
    } else {
      console.log("Changing order from", this.props.filters.get('order'), "to", order);
      this.props.actions.updateFilter({ order });
      caseLookupSearch.bind(this)({ order }, false);
    }
  };

  pacerSearch = (e) => {
    e.preventDefault();

    this.props.history.push('/filings/search-bankruptcy-records');

    const filters = this.props.filters.toJS();

    // TODO: Translate National:Cofce into Civil search with said court - quirk of PCL

    // additions to filters
    filters.case_title = filters.party_title;

    const region = filters.region_name || '';

    if (region.includes(',')) {
      filters.court_id = (region).split(',').reduce((accum, next, idx) => {
        // pacer regions are actual regions so all caps
        if (next === next.toUpperCase()) {
          const x = (idx === 0)
            ? next
            : `,${next}`;

          return accum += x;
        }
        return accum;
      }, '');
    } else {
      filters.court_id = (region === region.toUpperCase())
        ? region
        : '';
    }

    // not used in pacer search
    delete filters.party_title;
    delete filters.order;
    delete filters.search_type;
    delete filters.page;
    delete filters.year;
    delete filters.court_name;
    delete filters.court_code;
    delete filters.region_name;

    // All only exists on Case Lookup form.  Default to Bankruptcy for others
    filters.case_type = (filters.case_type === 'All')
      ? 'Bankruptcy'
      : filters.case_type;

    // filter out pacer search
    this.props.actionsOfPacerSearch.updateFilter(filters);

    const clientCodeErr = (!client_code_is_valid())
      ? { messages: ['Please set a valid client code first.'] }
      : null;

    if (clientCodeErr) {
      this.props.actionsOfPacerSearch.receiveError(errorConstants.VALIDATION_ERROR, clientCodeErr);
    } else {
      this.searchAction[filters.case_type](Immutable.fromJS(filters));
    }
  };

  isNoResultWarningMessageShow = () => {
    const initialFilters = _.cloneDeep(initialFilters);
    const currentFilters = this.props.filters.toJS();

    return !_.isEqual(
      _.omit(initialFilters, 'case_type'),
      _.omit(currentFilters, 'case_type'),
    ) && this.props.isReady;
  };

  clickPage = (page) => {
    this.props.actions.updateFilter({ page });
    caseLookupSearch.bind(this)({ page }, false);
  }

  render() {
    // todo - bunch of this is duplicated from ResultsTable.js.  Adding for now, but should refactor into a component later
    const case_type = this.props.filters.get('case_type');
    const nosOrChpHeader = (case_type === 'Bankruptcy')
      ? 'Chp'
      : (case_type === 'All')
        ? 'Chp/NOS'
        : 'NOS';

    const headers = [
      'Case Title', 'Party Name', 'Court', 'Case No', nosOrChpHeader, 'Date Filed', 'Disposition',
    ].map((header, index) => {
      const order = this.props.filters.get('order');

      const className = header.toLowerCase().split(' ').join('-');
      const colspan = (header === 'Party Name')
        ? '2'
        : '1';

      return (
        <th key={index} className={className} colSpan={colspan}>
          <ResultColumnHeadTextFormElement
            isSelected={order === header}
            onClick={this.changeOrder.bind(this, header)}>{header}
          </ResultColumnHeadTextFormElement>
          <ArrowFormElement
            show={order === header}
            onClick={this.changeSortBy}
            sort={this.props.filters.get('sort')} />
        </th>
      );
    });

    // todo - this is duplicated from ResultsTable.js.  Adding like this for now, but we should refactor into a component later
    const pages = this.props.pages.toJS();
    let paginatorItems = null;

    if (pages.totalitems > 0) {
      const currPage = this.props.filters.get('page');
      const numPages = Math.ceil(pages.totalitems / pages.pagesize);
      const max = 10;

      const pageIconCount = (numPages <= max)
        ? numPages
        : max;

      // 22
      // 1  - 1, 2, 3, 4, 5, 6, 7, 8, 9, ... 22
      // 5  - 1, 2, 3, 4, 5, 6, 7, 8, 9, ... 22
      // 2  - 1, 2, 3, 4, 5, 6, 7, 8, 9, ... 22
      // 20 - 1, ... , 14, 15, 16, 17, 18, 19, 20, 21, 22
      // 10 - 1 ..., 7, 8, 9, 10, 11, 12, 13, ... 22
      // 12 - 1, ...,  14, 15, 16, 17, 18, 19, 20, 21, 22

      paginatorItems = _.range(pageIconCount);

      if (currPage < max) {
        // take 1-9 + numPages
        paginatorItems = paginatorItems.map((el, idx) => {
          if (idx === paginatorItems.length - 1) {
            return numPages;
          }
          return idx + 1;
        });
      } else if (currPage >= numPages - max + 2) {
        // 1 + take currPage - max   (ex: 14)
        // 1 + take curr Page - max  (ex 10) with 12
        paginatorItems = paginatorItems.map((el, idx) => {
          if (idx === paginatorItems.length - 1) {
            return 1;
          }
          return numPages - idx;
        }).reverse();
      } else {
        // ex case 13
        // 1.. (1-4 range) currPage (1-4 range)..max
        // 1,...  9, 10, 11, 12, 13, 14, 15, 16, 17, ..22
        paginatorItems = paginatorItems.map((el, idx) => {
          if (idx === 0) {
            return 1;
          }
          if (idx === paginatorItems.length - 1) {
            return numPages;
          }
          return currPage + idx - 5;
        });
      }

      const previousItem = {
        nextPage: (currPage !== 1 && numPages > 1) ? currPage - 1 : currPage,
        page: 'Previous',
      };

      const previousPage = <PaginatorItem key="prev" item={previousItem} clickPage={this.clickPage} />;

      const nextItem = {
        nextPage: (currPage !== numPages) ? currPage + 1 : currPage,
        page: 'Next',
      };
      const nextPage = <PaginatorItem key="next" item={nextItem} clickPage={this.clickPage} />;

      paginatorItems = paginatorItems.reduce((accum, el, idx) => {
        const item = { page: el, active: (currPage === el) };
        const key = `page-item-${idx}`;

        if (idx !== 0 && paginatorItems[idx - 1] !== paginatorItems[idx] - 1) {
          return accum.concat([<span>...</span>, <PaginatorItem key={key} item={item} clickPage={this.clickPage} />]);
        }
        return accum.concat([<PaginatorItem key={key} item={item} clickPage={this.clickPage} />]);
      }, []);

      paginatorItems.unshift(previousPage);
      paginatorItems.push(nextPage);
    }

    const results = this.props.contents.map(({ meta }, index) => {
      const nclParties = meta.ncl_parties || [];
      const partieNames = nclParties.map((p, i) => (
        <div key={i}>{p.name} {`(${p.role})`}</div>
      ));

      return (
        <tr key={index} className={index % 2 === 0 ? 'even' : 'odd'}>
          <td>{meta.title}</td>
          <td colSpan="2" className="party-name">{partieNames}</td>
          <td><abbr title={meta.title}>{meta.court}</abbr></td>
          <td className="ir-search-no-wrap" style={{ fontWeight: 'bold' }}>
            <a href={`/filings/${meta.case_uuid}`}>{meta.case_no}</a>
          </td>
          <td>{meta.chapter || meta.nature_of_suit_code || ''}</td>
          <td>{meta.date_filed}<br />{meta.date_closed}</td>
          <td className="disposition">{meta.disposition}</td>
        </tr>
      );
    });

    const filedFrom = this.props.filters.get('filed_from');
    const filedTo = this.props.filters.get('filed_to');
    const regionOptions = this.regionOptions[this.props.filters.get('case_type')] || [];
    const filtersForRegions = this.props.filters.mapKeys(k => {
      if (k === "court_id")
        return "region_name";
      return k;
    });

    const expandRegionSelector = ((filtersForRegions.get('region_name') || '').split(',').length > 2)
      ? '764px'
      : '386px';

    return (
      <div className="pacer-search-container case-lookup">

        <div className="filings-form">
          <SearchTypesOfCaseLookup
            onChange={this.stateValueSet.bind(this, 'case_type')}
            selectedSearchType={this.props.filters.get('case_type')}
            listOfSearchTypes={searchTypes} />

          <div className="search-form-container">
            <div>
              <CaseNumberSelector
                showFlash={this.state.caseNumShowFlash}
                onChange={this.stateValueSet.bind(this, 'case_no')}
                value={this.props.filters.get('case_no')} />
              <ActionButtonOfCaseLookup
                onClick={this.searchClickHandle.bind(this, 'case_no')} />
            </div>
            <OrSeparator />
            <div>
              <CaseTitleSelector
                showFlash={this.state.caseTitleShowFlash}
                onChange={this.stateValueSet.bind(this, 'party_title')}
                value={this.props.filters.get('party_title')}

              />
              <ActionButtonOfCaseLookup
                onClick={this.searchClickHandle.bind(this, 'party_title')} />
            </div>

            <Collapsible title="Filters" initCollapsed={false}>
              <RegionSelector
                width={expandRegionSelector}
                courtField="region_name"
                filters={filtersForRegions}
                regionOptions={sortRegions(regionOptions)}
                onChange={this.stateValueSet.bind(this, 'region_name')} />
              <div></div>
              <div className="date-picker-container">
                <label className="date-picker-label">Date filed from:</label>
                <DatePicker
                  selected={filedFrom}
                  onChange={this.stateValueSet.bind(this, 'filed_from')}
                  dateFormat="MM/DD/YYYY"
                  isClearable
                  className="date-picker"
                  onChangeRaw={event => this.handleDateChangeRaw('filed_from', event.target.value)} />
              </div>
              <div className="date-picker-container">
                <label className="date-picker-label">through:</label>
                <DatePicker
                  selected={filedTo}
                  onChange={this.stateValueSet.bind(this, 'filed_to')}
                  dateFormat="MM/DD/YYYY"
                  isClearable
                  className="date-picker"
                  onChangeRaw={event => this.handleDateChangeRaw('filed_to', event.target.value)} />
              </div>
            </Collapsible>

            <AlertError />
          </div>

          <Loading />
          {this.props.contents.length ? (
            <div id="basic-search-results">
              <div className="warning" style={{ textAlign: 'center' }}>
                Click on desired case number to continue
              </div>
              <div className="item-list">
                <ul style={{ margin: '20px 0 0 0' }} className="pager">
                  { paginatorItems }
                </ul>
              </div>
              <table className="ir-search-table-results sticky-enabled sticky-table">
                <thead className="tableHeader-processed">
                  <tr>{headers}</tr>
                </thead>
                <tbody>{results}</tbody>
              </table>
              <div className="item-list">
                <ul style={{ margin: '20px 0 0 0' }} className="pager">
                  { paginatorItems }
                </ul>
              </div>
              <div className="free-search-results warning">
                If your case was not listed above,
                <a
                  onClick={this.pacerSearch}
                  href="#ir-search-tab-2"
                  className="free-search-results"> click here </a>
                to immediately check PACER <span className="charges-apply">(PACER charges apply)</span>
              </div>
            </div>
          ) :
            this.props.isError
            ? <div className="alert alert-danger">
                There was an error searching, please try again or contact support if the problem persists.
              </div>
            : this.isNoResultWarningMessageShow() && (
            <div className="messages">
              <a
                onClick={this.pacerSearch}
                href="#ir-search-tab-2"
                className="form-submit green"
                style={{ float: 'right', marginRight: '120px', marginTop: '4px' }}>Continue</a> Free search does not have matches so we'll check PACER for you next
              <small style={{ whiteSpace: 'nowrap' }}> (PACER charges apply)</small>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const caseLookupSearchReducer = state.get('caseLookupSearchReducer');

  return {
    filters: caseLookupSearchReducer.get('filters'),
    pages: caseLookupSearchReducer.get('pages'),
    facets: caseLookupSearchReducer.get('facets'),
    contents: caseLookupSearchReducer.get('contents') || [],
    isReady: caseLookupSearchReducer.get('isReady'),
    isError: caseLookupSearchReducer.get('isError'),
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
  actionsOfPacerSearch: bindActionCreators(actionsOfPacerSearch, dispatch),
  actions: bindActionCreators(actions, dispatch),
  errorActions: bindActionCreators(errorActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CaseLookupSearch);



// WEBPACK FOOTER //
// ./src/pages/filings/CaseLookup/CaseLookup.jsx